import { render } from "./Main.vue?vue&type=template&id=4101a531"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4101a531&lang=css"

import exportComponent from "/Users/macmeow/Documents/vue/feedback_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__